"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Result_exports = {};
__export(Result_exports, {
  Failure: () => Failure,
  Result: () => Result,
  Success: () => Success,
  isResult: () => isResult
});
module.exports = __toCommonJS(Result_exports);
var import_guard = require("@cartographerio/guard");
var import_util = require("@cartographerio/util");
var import_Option = require("./Option.js");
function wrapGuardHint(guard2, hint) {
  if (hint != null) {
    return hint;
  } else if (typeof guard2 === "string") {
    return guard2;
  } else if (typeof guard2 === "function" && guard2.name != null) {
    return guard2.name;
  } else {
    return "<UnknownGuard>";
  }
}
class Success {
  constructor(value) {
    this.chain = (func) => {
      const b = func(this._value);
      if (b instanceof Success || b instanceof Failure) {
        return b;
      } else {
        return new Success(b);
      }
    };
    this.map = (func) => {
      return new Success(func(this._value));
    };
    this.flatMap = (func) => {
      return func(this._value);
    };
    this.flatMapU = (func) => {
      return func(this._value);
    };
    this.tap = (func) => {
      return this.map((a) => {
        func(a);
        return a;
      });
    };
    this.mapError = (_func) => {
      return this;
    };
    this.tapError = (_func) => {
      return this;
    };
    this.recover = (_func) => {
      return this;
    };
    this.filter = (func, orElse) => {
      return func(this._value) ? this : new Failure(orElse());
    };
    this.guardWith = (guard2, orElse) => {
      return guard2(this._value) ? this : new Failure(orElse(this._value));
    };
    this.guard = (guard2, hint) => {
      return this.guardWith(guard2, (value) => (0, import_guard.guardError)(wrapGuardHint(guard2, hint), guard2, value));
    };
    this.fold = (_ifFailure, ifSuccess) => {
      return ifSuccess(this._value);
    };
    this.forEach = (func) => {
      func(this._value);
    };
    this.swap = () => {
      return new Failure(this._value);
    };
    this.union = () => {
      return this._value;
    };
    this.isSuccess = () => {
      return true;
    };
    this.isFailure = () => {
      return false;
    };
    this.toOption = () => {
      return import_Option.Option.some(this._value);
    };
    this.toErrorOption = () => {
      return import_Option.Option.none();
    };
    this.toArray = () => {
      return [this._value];
    };
    this.orElse = (_func) => {
      return this;
    };
    this.unsafeGet = () => {
      return this._value;
    };
    this.unsafeError = () => {
      throw new Error(`Called unsafeError on a Success: ${(0, import_util.prettyPrintJson)(this._value)}`);
    };
    this.getOrElse = (_func) => {
      return this._value;
    };
    this.getOrThrow = () => {
      return this._value;
    };
    this.getOrNull = () => {
      return this._value;
    };
    this.getOrUndefined = () => {
      return this._value;
    };
    this._value = value;
  }
}
class Failure {
  constructor(error) {
    this.chain = (_func) => {
      return this;
    };
    this.map = (_func) => {
      return this;
    };
    this.flatMap = (_func) => {
      return this;
    };
    this.flatMapU = (_func) => {
      return new Failure(this._error);
    };
    this.tap = (_func) => {
      return this;
    };
    this.mapError = (func) => {
      return new Failure(func(this._error));
    };
    this.tapError = (func) => {
      return this.mapError((e) => {
        func(e);
        return e;
      });
    };
    this.recover = (func) => {
      const b = func(this._error);
      if (b instanceof Success || b instanceof Failure) {
        return b;
      } else {
        return new Success(b);
      }
    };
    this.filter = (_func, _orElse) => {
      return this;
    };
    this.guardWith = (_guard, _orElse) => {
      return this;
    };
    this.guard = (_guard, _hint) => {
      return this;
    };
    this.fold = (ifFailure, _ifSuccess) => {
      return ifFailure(this._error);
    };
    this.forEach = (_func) => {
      return;
    };
    this.swap = () => {
      return new Success(this._error);
    };
    this.union = () => {
      return this._error;
    };
    this.isSuccess = () => {
      return false;
    };
    this.isFailure = () => {
      return true;
    };
    this.toOption = () => {
      return import_Option.Option.none();
    };
    this.toErrorOption = () => {
      return import_Option.Option.some(this._error);
    };
    this.toArray = () => {
      return [];
    };
    this.orElse = (func) => {
      return func();
    };
    this.unsafeGet = () => {
      throw new Error(`Called unsafeGet on a Failure: ${(0, import_util.prettyPrintJson)(this._error)}`);
    };
    this.unsafeError = () => {
      return this._error;
    };
    this.getOrElse = (func) => {
      return func(this._error);
    };
    this.getOrThrow = () => {
      throw this._error;
    };
    this.getOrNull = () => {
      return null;
    };
    this.getOrUndefined = () => {
      return void 0;
    };
    this._error = error;
  }
}
function pure(value) {
  return new Success(value);
}
function pass(value) {
  return new Success(value);
}
function fail(error) {
  return new Failure(error);
}
function wrap(error) {
  return function(value) {
    return value == null ? fail(error()) : pure(value);
  };
}
function cond(cond2) {
  return function(fail2, pass2) {
    return cond2 ? Result.pass(pass2()) : Result.fail(fail2());
  };
}
function tupled(results) {
  const values = [];
  for (const result of results) {
    if (result instanceof Success) {
      values.push(result._value);
    } else if (result instanceof Failure) {
      return fail(result._error);
    } else {
      throw new Error("Unknown Result type: " + result);
    }
  }
  return pure(values);
}
function when(...results) {
  const result = tupled(results);
  return (func) => result.map((values) => func(...values));
}
function sequence(results) {
  const args = [];
  for (const result of results) {
    if (result instanceof Success) {
      args.push(result._value);
    } else if (result instanceof Failure) {
      return fail(result._error);
    } else {
      throw new Error("Unknown Result type: " + result);
    }
  }
  return pass(args);
}
function traverse(as) {
  return function(func) {
    const args = [];
    for (const a of as) {
      const result = func(a);
      if (result instanceof Success) {
        args.push(result._value);
      } else if (result instanceof Failure) {
        return fail(result._error);
      } else {
        throw new Error("Unknown Result type: " + result);
      }
    }
    return pass(args);
  };
}
function reduceWith(as, memo, func) {
  return as.reduce((b, a) => b.flatMap((b2) => func(b2, a)), memo);
}
function reduce(as, memo, func) {
  return reduceWith(as, Result.pure(memo), func);
}
function guard(guard2, hint) {
  return (value) => {
    return Result.pure(value).guard(guard2, hint);
  };
}
function guardWith(guard2, orElse) {
  return (value) => {
    return Result.pure(value).guardWith(guard2, orElse);
  };
}
const Result = {
  pure,
  pass,
  fail,
  wrap,
  cond,
  when,
  tupled,
  sequence,
  traverse,
  reduce,
  reduceWith,
  guard,
  guardWith
};
function isResult(isE, isA) {
  return function(value) {
    if (value instanceof Failure) {
      return isE(value._error);
    } else if (value instanceof Success) {
      return isA(value._value);
    } else {
      return false;
    }
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Failure,
  Result,
  Success,
  isResult
});
//# sourceMappingURL=Result.js.map
